import { fromJS } from 'immutable'
import {
  ACCOUNTING_BILLING_GET_REQUEST,
  ACCOUNTING_BILLING_GET_SUCCESS,
  ACCOUNTING_BILLING_GET_FAILURE,
  ACCOUNTING_BILLING_GET_RESET,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_BILLING_GET_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_BILLING_GET_SUCCESS:
      return state
        .set('accountantBilling', fromJS(action.payload.accountantBilling))
        .set('isFetching', false)
    case ACCOUNTING_BILLING_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case ACCOUNTING_BILLING_GET_RESET:
      return state
        .set('isFetching', false)
        .set('accountantBilling', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/billing-get-reducer.js